<template>
  <div class="d-flex justify-end py-2 dashboard-header">
    <div class="filter-group d-flex align-center">
      <div class="filter-pill">
        <button
          v-for="filter in filters"
          :key="filter"
          class="filter-btn"
          :class="{ active: value === filter }"
          :disabled="disabled"
          @click="$emit('input', filter)"
        >
          {{ filter }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'

export default {
	name: 'DashboardHeader',
	props: {
		value: {
			type: String,
			default: 'Monthly',
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	setup() {
		const filters = ref(['Daily', 'Weekly', 'Monthly', 'Yearly'])

		return { filters }
	},
}
</script>

<style lang="scss" scoped>
.dashboard-header {
	width: 100%;
}

.filter-pill {
	background: #f1f5fd;
	padding: 6px;
	border-radius: 40px;
	display: flex;
	gap: 5px;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.filter-btn {
	border-radius: 30px !important;
	padding: 6px 18px;
	font-size: 14px;
	background: linear-gradient(135deg, #0b2240 0%, #1f4978 50%, var(--v-primary-base) 100%) !important;
	-webkit-background-clip: text !important;
	-webkit-text-fill-color: transparent !important;
	border: none !important;
	outline: none !important;
	cursor: pointer;
	font-weight: 600;
	transition: all 0.2s ease;

	&:disabled {
		cursor: not-allowed;
		opacity: 0.55;
		pointer-events: none;
	}

	&:hover {
		background: rgba(31, 73, 120, 0.05) !important;
	}

	&.active {
		background: linear-gradient(135deg, #0b2240 0%, #1f4978 50%, var(--v-primary-base) 100%) !important;
		-webkit-text-fill-color: #fff !important;
		color: #fff !important;
		box-shadow: 0 2px 6px rgba(31, 73, 120, 0.25);
	}
}
</style>
